import { Component, Input } from '@angular/core';

@Component({
  selector: 'pty-customer-contacts',
  templateUrl: './customer-contacts.component.html',
  styleUrls: ['./customer-contacts.component.scss']
})
export class CustomerContactsComponent {
  @Input() partyId:string;
  hasValue = false;
  /**
   * CustomerPostalAddress
   * CustomerTelecomNumber
   * CustomerEmailAddress
   */
}
